import {
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';

import {
  ControlContainer,
  NgForm
} from '@angular/forms';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-select-control',
  styles: [ require('./select-control.component.scss') ],
  template: require('./select-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class SelectControlComponent extends TextControlComponent {
  @Input() hasDefaultOption = false;
  /**
   * In order to match empty values to the placeholder value,
   * we need to ensure that undefined is not used, only null.
   */
  @Input() set model ( _model : any ) {
    if ( _model === undefined ) {
      this._model = null;
    }
    else {
      this._model = _model;
    }
  };

  @ViewChild('elementRef') elementRef !: ElementRef;

  handleModelChange ( event : any ) {
    this.modelChange.emit(event);

    this.elementRef.nativeElement.blur();
  }
}